/**
 * This is separate from the panel-config to avoid circular reference - the grid uses this for saved views
 */
export const AccountListKey = 'account-list-3g7g0' // <-- DO NOT CHANGE THIS. The layout manager depends on this value.
